import { render, staticRenderFns } from "./send-indications-icon2-box.vue?vue&type=template&id=5ca8164a&scoped=true&"
import script from "./send-indications-icon2-box.vue?vue&type=script&lang=js&"
export * from "./send-indications-icon2-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8164a",
  null
  
)

export default component.exports